import { render, staticRenderFns } from "./PartnerRegisterSearchIframe.vue?vue&type=template&id=07ecb0d8&"
import script from "./PartnerRegisterSearchIframe.vue?vue&type=script&lang=ts&"
export * from "./PartnerRegisterSearchIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports